import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { createScaffolderFieldExtension } from '@backstage/plugin-scaffolder-react';
import {
  GithubUserVerification,
  GithubUserVerificationValidation,
} from './GithubUserVerification';

export const GithubUserVerificationFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'GithubUserVerification',
    component: GithubUserVerification,
    validation: GithubUserVerificationValidation,
    schema: {
      returnValue: {
        type: 'string',
        title: 'GitHub login',
        description:
          'The verified GitHub Enterprise login for the email address.',
      },
      uiOptions: {
        type: 'object',
        properties: {
          emailField: {
            type: 'string',
            title: 'Email field',
            description:
              'Name of the template parameter that contains the email address to verify. If omitted or empty, the logged-in user email is used.',
          },
          preventNonNestleUsers: {
            type: 'boolean',
            title: 'Prevent non-Nestle users',
            description:
              'When true, only nestle.com email addresses are accepted before GitHub verification. Defaults to true.',
            default: true,
          },
        },
      },
    },
  }),
);
